export enum IssueType {
  Bug = 'Bug',
  Feature = 'Feature'
}
